import { FunctionComponent } from 'react';

export const LocalNotificationsSettings: FunctionComponent = () => null;
